import { hocHook } from "../../../@hoc/hoc-hook";
import { Contact } from "./contact";

export default hocHook(Contact);
